import React from 'react';
import PreviewOneOnOneSchedule from './PreviewOneOnOne/PreviewOneOnOne';
import PreviewGroupSchedule from './PreviewGroup/PreviewGroup';
import PreviewPrimeSchedule from './PreviewPrime/PreviewPrime';
import PreviewPaused from './PreviewPaused/PreviewPaused';
import './PreviewModel.css'; // Import the new CSS file

const PreviewModal = ({ session, onClose, sessionsData = [], pauseSessionsData = [] }) => {
  // Always ensure we have a valid session object
  if (!session) {
    console.warn('No session provided to PreviewModal');
    return null;
  }

  // If session is just an ID, find the full session data
  let sessionData = session;

  if (typeof session === 'string') {
    // Try to find the session in sessionsData by ID
    sessionData = sessionsData.find(s => s.id === session);

    // If not found in sessions, check pause sessions
    if (!sessionData && pauseSessionsData) {
      sessionData = pauseSessionsData.find(s => s.id === session);
    }

    // If still not found, use the ID as is
    if (!sessionData) {
      console.warn(`Session with ID ${session} not found in data`);
      sessionData = session;
    }
  }

  console.log('Preview Modal session data:', sessionData);

  // Determine session type from the data
  let sessionType = 'one_on_one'; // Default

  if (sessionData.session_type) {
    sessionType = sessionData.session_type;
  } else if (sessionData.start && sessionData.end) {
    // This looks like a pause session
    sessionType = 'smart_pause';
  }

  console.log('Session type determined:', sessionType);

  // Create a wrapper component that applies PreviewModel-specific styling
  const PreviewWrapper = ({ children }) => (
    <div className="preview-model-container">
      <div className="preview-model-wrapper">{children}</div>
    </div>
  );

  // Render appropriate preview component based on session type
  if (sessionType === 'prime') {
    return (
      <PreviewWrapper>
        <PreviewPrimeSchedule open={true} onClose={onClose} session={sessionData} />
      </PreviewWrapper>
    );
  } else if (sessionType === 'group') {
    return (
      <PreviewWrapper>
        <PreviewGroupSchedule open={true} onClose={onClose} session={sessionData} />
      </PreviewWrapper>
    );
  } else if (sessionType === 'one_on_one') {
    return (
      <PreviewWrapper>
        <PreviewOneOnOneSchedule open={true} onClose={onClose} session={sessionData} />
      </PreviewWrapper>
    );
  } else if (sessionType === 'smart_pause') {
    // For now, we don't have a special preview for smart_pause, so show a message
    console.warn(`Smart pause session type doesn't have a dedicated preview component yet`);
    return (
      <PreviewWrapper>
        <PreviewPaused
          open={true}
          onClose={onClose}
          session={{
            ...sessionData,
            session_type: 'smart_pause',
            subject: 'Paused Availability',
            level_of_teaching: 'All',
          }}
        />
      </PreviewWrapper>
    );
  } else {
    // Unknown types - default to One-on-One for now
    console.warn(`Unknown session type: ${sessionType}, defaulting to one_on_one`);
    return (
      <PreviewWrapper>
        <PreviewOneOnOneSchedule open={true} onClose={onClose} session={sessionData} />
      </PreviewWrapper>
    );
  }
};

export default PreviewModal;
